import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import HeaderHomeTwo from "../../components/header-home-two/component";
import countryCodes from "country-telephone-data";
import scrollToComponent from 'react-scroll-to-component';
import {marketRegister} from "../../services/marketRegister";
import ModalVideo from "../../components/modal-video/component";
import {dataRegister} from "../../services/dataRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import ModalVip from "../../components/modal-vip/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";

import SCfaviconAppleTouch from '../../assets/saleschannel-favicon/apple-touch-icon.png';
import SCfavicon16 from '../../assets/saleschannel-favicon/favicon-16x16.png';
import SCfavicon32 from '../../assets/saleschannel-favicon/favicon-32x32.png';
import SCfaviconSiteManifest from '../../assets/saleschannel-favicon/site.webmanifest';
import SCfaviconSiteSafari from '../../assets/saleschannel-favicon/safari-pinned-tab.svg';

import ABfaviconAppleTouch from '../../assets/adbop-favicon/apple-touch-icon.png';
import ABfavicon16 from '../../assets/adbop-favicon/favicon-16x16.png';
import ABfavicon32 from '../../assets/adbop-favicon/favicon-32x32.png';
import ABfaviconSiteManifest from '../../assets/adbop-favicon/site.webmanifest';
import ABfaviconSiteSafari from '../../assets/adbop-favicon/safari-pinned-tab.svg';

import {Helmet} from 'react-helmet'

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            terms: false,
            isLoadingButton: false,
            countries: [],
            country: {},
            video: false,
            vip: false,
            form_validation: {},
            first_name: "",
            last_name: "",
            company: "",
            phone: "",
            zip: "",
            country_name: "",
            address: "",
            city: "",
            website: "",
            year: "",
            search: ""
        };
        this.signupRef = React.createRef();
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this._updateDate();
        this._updateTitle();
        this._updateCountries();
        this._setDomain(window.location.href);
        this._setVideo = this._setVideo.bind(this);
        this._setVip = this._setVip.bind(this);

        this.initializeReactGA();
        this.initializeReactGA4();
        this.initializeReactPixel();
    }

    initializeReactGA() {
        if(this.platformLive()){
            ReactGA.initialize('UA-133715853-10');
            ReactGA.pageview('/');
        }
    }

    initializeReactGA4() {
        if(this.platformLive()){
            ReactGA4.initialize('G-NYH0H2PFQ0');
            ReactGA4.send({ hitType: "pageview", page: "/" });
        }
    }

    initializeReactPixel() {
        if(this.platformLive()){
            ReactPixel.init('254729202280540');
            ReactPixel.pageView();
        }
    }

    platformLive() {
        try {
            return window.location.hostname.indexOf('dev') === -1;
        } catch (e) {
            return false
        }
    }

    _updateCountries() {
        let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
        for (let i = 0; i < countries.length; i++) {
            countries[i].dialCode = "+" + countries[i].dialCode;
            if (countries[i].iso2 === salesChannelRegister.get("market")) {
                this._selectCountry(countries[i]);
            }
        }
        this.setState({countries: countries});
    }

    _updateDate(){
        let date = new Date();
        let year = date.getFullYear();
        this.setState({year: year});
    }

    _updateTitle() {
        document.title = "Get your saleschannel today";
    }

    _setDomain(url) {
        if(this._getHostingUrl(url)){
            dataRegister.setDomain(this._getHostingUrl(url));
        }
    }

    _getHostingUrl(url) {
        try{
            var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
            if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
                return match[2];
            }
            else {
                return null;
            }
        }catch (e) {
            return null;
        }
    }

    _apply(){

        for (let key in this.state.form_validation) {
            this.state.form_validation[key] = false;
        }

        //CHECK VALUES
        this.state.form_validation.first_name = this.state.first_name === "" || !this.state.first_name;
        this.state.form_validation.last_name = this.state.last_name === "" || !this.state.last_name;
        this.state.form_validation.company = this.state.company === "" || !this.state.company;
        this.state.form_validation.address = this.state.address === "" || !this.state.address;
        this.state.form_validation.zip = this.state.zip === "" || !this.state.zip;
        this.state.form_validation.city = this.state.city === "" || !this.state.city;
        this.state.form_validation.country_name = this.state.country_name === "" || !this.state.country_name;
        this.state.form_validation.website = this.state.website === "" || !this.state.website;
        this.state.form_validation.email = !this._emailValidation(this.state.email);
        this.state.form_validation.phone = !this._phoneValidation(this.state.phone);
        try{
            this.state.form_validation.dialcode = !this.state.country.dialCode;
        }catch (e) {
            this.state.form_validation.dialcode = true;
        }

        this.setState({form_validation: this.state.form_validation});

        //CHECK IF TERMS IS SET
        if(!this.state.terms){return}

        let result = false;
        for (let key in this.state.form_validation) {
            if (this.state.form_validation[key]) {
                result = true;
                break;
            }
        }
        if(!result){
            this.setState({isLoadingButton: true});
            let information = {
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                company: this.state.company,
                address: this.state.address,
                zip: this.state.zip,
                city: this.state.city,
                country_name: this.state.country_name,
                website: this.state.website,
                email: this.state.email,
                phone: (this.state.country.dialCode&&this.state.phone!=="")?(this.state.country.dialCode + this.state.phone):this.state.phone,
            };
            let data = {email: this.state.email, name: JSON.stringify(information), subject: "saleschannel request", message: "se"};
            dataRegister.industryRequest("se", "saleschanneldemo", data).then((response) => {
                this.setState({
                    isLoadingButton: false,
                    vip: true,
                    first_name: "",
                    last_name: "",
                    company: "",
                    address: "",
                    zip: "",
                    city: "",
                    country_name: "",
                    website: "",
                    email: "",
                    phone: "",
                    terms: false
                });

                //GOOGLE EVENT
                if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                    ReactGA.event({category: 'User', action: 'Applied saleschannel', label: 'Home'});
                    ReactGA4.event({category: 'User', action: 'Applied saleschannel', label: 'Home'});
                    //console.log("Fire event VIP");
                }

                //FACEBOOK EVENT
                if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                    ReactPixel.trackCustom('ApplySaleschannel');
                }

            }, (error) => {
                this.setState({isLoadingButton: false});
            });
        }

    }

    _scrollTo(){
        scrollToComponent(this.signupRef.current, {offset: -150, duration: 500});
    }

    _selectCountry(option) {
        this.setState({country: option, search: option.dialCode});
    }

    _terms(link){
        window.open('https://legal.'+dataRegister.domain+"/se/en/"+link+"/saleschanneldemo", '_blank');
    }

    _primehit(){
        window.open('https://primehit.com', '_blank');
    }

    _setVideo(value){
        this.setState({video: value});
    }

    _setVip(value){
        this.setState({vip: value});
    }

    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _urlValidation(url) {
        var re = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/;
        return re.test(String(url).toLowerCase());
    }

    _phoneValidation(number) {
        var re = /^[0-9 +]+$/;
        if (re.test(String(number).toLowerCase()) && number.length > 5) {
            return true
        } else {
            false
        }
    }

    _renderText(item) {
        return langRegister.get("vip", item, "en");
    }

    render() {
        return (
              <div className={Styles.view}>
                  {
                      window.location.hostname.indexOf("adbop") === -1 &&
                      <Helmet>
                          <link rel="apple-touch-icon" sizes="120x120" href={SCfaviconAppleTouch}/>
                          <link rel="icon" type="image/png" sizes="32x32" href={SCfavicon32}/>
                          <link rel="icon" type="image/png" sizes="16x16" href={SCfavicon16}/>
                          <link rel="manifest" href={SCfaviconSiteManifest}/>
                          <link rel="mask-icon" href={SCfaviconSiteSafari} color="#000000"/>
                          <meta name="msapplication-TileColor" content="#41CBC7"/>
                          <meta name="theme-color" content="#FFFFFF"/>
                          <meta name="description" content="The customizable self-service solution for inhouse teams looking for instant performance, simply launch agency grade campaigns in minutes and enjoy close to zero admin – pay only for performance. Leverage AI driven multi-channel advertising across Google, Facebook, Instagram, Bing and many more"/>
                      </Helmet>
                  }
                  {
                      window.location.hostname.indexOf("adbop") !== -1 &&
                      <Helmet>
                          <link rel="apple-touch-icon" sizes="180x180" href={ABfaviconAppleTouch}/>
                          <link rel="icon" type="image/png" sizes="32x32" href={ABfavicon32}/>
                          <link rel="icon" type="image/png" sizes="16x16" href={ABfavicon16}/>
                          <link rel="manifest" href={ABfaviconSiteManifest}/>
                          <link rel="mask-icon" href={ABfaviconSiteSafari} color="#000000"/>
                          <meta name="msapplication-TileColor" content="#41CBC7"/>
                          <meta name="theme-color" content="#FFFFFF"/>
                          <meta name="description" content="adBop is a one-stop-shop for online advertisers with little or no prior marketing skills looking for instant performance, simply launch agency grade campaigns in minutes and enjoy close to zero admin – pay only for performance. Leverage AI driven multi-channel advertising across Google, Facebook, Instagram, Bing and many more"/>
                      </Helmet>
                  }
                  {
                      this.state.video &&
                      <ModalVideo setVideo={this._setVideo} props={this.props}/>
                  }
                  {
                      this.state.vip &&
                      <ModalVip setVip={this._setVip} props={this.props}/>
                  }
                  <HeaderHomeTwo view={"vip"} props={this.props}/>
                  <div className={Styles.sectionOne}>
                      <img onClick={() => this._setVideo(true)} className={Styles.sectionOneImageMobile} src={require("../../assets/images/AB_figures_mobile_reseller_2.png")}/>
                      <div className={Styles.sectionOneInner}>
                          <div onClick={() => this._setVideo(true)}  style={{position: "absolute", top: 0, bottom: 0, left: 0, right: 0}}/>
                          <div className={Styles.sectionOneText}>
                              <span className={Styles.sectionOneTextTwo}>{this._renderText("item_1")}</span> {this._renderText("item_32")}
                              <div className={Styles.sectionOneTextGreen}>{this._renderText("item_2")}</div>
                              <div className={Styles.sectionOneTextGreenSmall}>
                                  {this._renderText("item_3")}
                              </div>
                              <div onClick={() => this._scrollTo()} className={Styles.sectionOneButton}>
                                  {this._renderText("item_4")}
                              </div>
                          </div>
                          <div className={Styles.sectionOneFiller}/>
                      </div>
                      <div className={Styles.sectionOneImage}>
                          <img className={Styles.sectionOneImageItem} src={require("../../assets/images/AB_figures_desktop_reseller_2.png")}/>
                      </div>
                      <img className={Styles.sectionOneShadow}
                           src={require("../../assets/images/AB_shadow_horisontal2_desktop_reseller.png")}/>
                      <img className={Styles.sectionOneShadowMobile}
                           src={require("../../assets/images/AB_shadow_horisontal2_mobile_reseller.png")}/>
                  </div>
                  <div className={Styles.sectionTwo}>
                      <div className={Styles.sectionTwoInner}>
                          <div className={Styles.sectionTwoText}>
                              {this._renderText("item_5")}
                              <div className={Styles.sectionTwoTextSubtitle}>
                                  {this._renderText("item_6")}
                              </div>
                              <div className={Styles.sectionTwoTextSmall}>
                                  {this._renderText("item_7")}
                              </div>
                              <div className={Styles.sectionTwoTextBullets}>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                    <div className={Styles.sectionTwoTextBulletsItemText}>
                                        {this._renderText("item_8")}
                                    </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_9")}
                                      </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_10")}
                                      </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_11")}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.sectionTwoImage}>
                              <img className={Styles.sectionTwoImageItem}
                                   src={require("../../assets/images/SC_iPad_Landscape.png")}/>
                          </div>
                      </div>
                      <img className={Styles.sectionTwoShadowMobile}
                           src={require("../../assets/images/AB_shadow_horisontal2_mobile_reseller.png")}/>
                      <img className={Styles.sectionTwoShadowBottom}
                           src={require("../../assets/images/AB_shadow_horisontal2_desktop_reseller.png")}/>
                  </div>
                  <div ref={this.signupRef} className={Styles.sectionThree}>
                      <div className={Styles.sectionThreeInnerTop}>
                          <div className={Styles.sectionThreeText}>
                              {this._renderText("item_12")}&nbsp;<span className={Styles.sectionThreeTextGreen}>{this._renderText("item_13")}</span>
                          </div>
                      </div>
                      <div className={Styles.sectionThreeInnerBottom}>
                          {
                              false &&
                              <div className={Styles.sectionThreeSubtitle}>
                                  {this._renderText("item_14")}
                              </div>
                          }
                          <div className={Styles.sectionThreeDivider}>
                              <div className={Styles.sectionThreeDividerTitle}>
                                  {this._renderText("item_15")}
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({first_name: event.target.value})} className={cx(Styles.input)} value={this.state.first_name} placeholder={this._renderText("item_16")}/>
                                  {
                                      this.state.form_validation.first_name && this.state.first_name === "" &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({last_name: event.target.value})} className={cx(Styles.input)} value={this.state.last_name} placeholder={this._renderText("item_17")}/>
                                  {
                                      this.state.form_validation.last_name && this.state.last_name === "" &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({company: event.target.value})} className={cx(Styles.input)} value={this.state.company} placeholder={this._renderText("item_18")}/>
                                  {
                                      this.state.form_validation.company && this.state.company === "" &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({address: event.target.value})} className={cx(Styles.input)} value={this.state.address} placeholder={this._renderText("item_19")}/>
                                  {
                                      this.state.form_validation.address && this.state.address === "" &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({zip: event.target.value})} className={cx(Styles.input)} value={this.state.zip} placeholder={this._renderText("item_20")}/>
                                  {
                                      this.state.form_validation.zip && this.state.zip === "" &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({city: event.target.value})} className={cx(Styles.input)} value={this.state.city} placeholder={this._renderText("item_21")}/>
                                  {
                                      this.state.form_validation.city && this.state.city === "" &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({country_name: event.target.value})} className={cx(Styles.input)} value={this.state.country_name} placeholder={this._renderText("item_22")}/>
                                  {
                                      this.state.form_validation.country_name && this.state.country_name === "" &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({website: event.target.value.toLowerCase()})} className={cx(Styles.input)} value={this.state.website} placeholder={this._renderText("item_23")}/>
                                  {
                                      this.state.form_validation.website && !this._urlValidation(this.state.website) &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({email: event.target.value.toLowerCase()})} className={cx(Styles.input)} value={this.state.email} placeholder={this._renderText("item_24")}/>
                                  {
                                      this.state.form_validation.email && !this._emailValidation(this.state.email) &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <div className={Styles.inputDividerItemInner}>
                                      <div className={Styles.inputDividerItemInnerDropdown}>
                                          <input
                                              placeholder={this._renderText("item_31")}
                                              type="tel"
                                              onFocus={() => this.setState({dropdown: true})}
                                              onBlur={() => this.setState({dropdown: false})}
                                              value={this.state.search}
                                              onChange={(event) => this.setState({search: event.target.value}, () => {
                                                  if(this.state.search !== this.state.country.dialCode){
                                                      console.log(this.state.country.dialCode);
                                                      this.setState({country: {}});
                                                  }
                                              })}
                                              className={Styles.inputDividerItemInnerDropdownInput}
                                          />
                                          {
                                              this.state.dropdown && this.state.countries.filter((item) => {
                                                  return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                              }).length > 0 &&
                                              <div className={Styles.dropdownList}>
                                                  {
                                                      this.state.countries.filter((item) => {
                                                          return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                      }).map((prop, key) => {
                                                          return (
                                                              <div key={key}
                                                                   onMouseDown={() => this._selectCountry(prop)}
                                                                   className={Styles.dropdownListItem}>
                                                                  {prop.dialCode}
                                                              </div>
                                                          )
                                                      })
                                                  }
                                              </div>
                                          }
                                          {
                                              this.state.form_validation.dialcode && !this.state.country.dialCode &&
                                              <div className={Styles.inputError}/>
                                          }
                                      </div>
                                      <div className={Styles.inputDividerItemInnerInput}>
                                          <input
                                              type="tel"
                                              value={this.state.phone}
                                              onChange={(event) => this.setState({phone: event.target.value.trim()})}
                                              className={Styles.input}
                                              placeholder={this._renderText("item_25")}
                                          />
                                          {
                                              this.state.form_validation.phone && !this._phoneValidation(this.state.phone) &&
                                              <div className={Styles.inputError}/>
                                          }
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.inputDividerItem}>
                              <div className={Styles.checkMarksContainerItem}>
                                  {
                                      !this.state.terms &&
                                      <img onClick={() => this.setState({terms: true})}
                                           src={require("../../assets/images/square_checkmark_two.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  {
                                      this.state.terms &&
                                      <img onClick={() => this.setState({terms: false})}
                                           src={require("../../assets/images/square_checkmark_active.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  <div className={Styles.checkMarksContainerItemText}>
                                      {this._renderText("item_29")} <span onClick={() => this._terms("terms")} className={Styles.checkMarksContainerItemTextBold}>{this._renderText("item_30")}</span>
                                  </div>
                              </div>
                          </div>
                          <div onClick={() => this._apply()} className={Styles.sectionThreeButton}>
                              {
                                  this.state.isLoadingButton &&
                                  <BeatLoader size={9} color={'#ffffff'} loading={true}/>
                                  ||
                                  <span>{this._renderText("item_26")}</span>
                              }
                          </div>
                      </div>
                  </div>
                  <div className={Styles.footer}>
                      <div className={Styles.footerText}>
                          <span className={Styles.footerTextItem} onClick={() => this._terms("terms")}>Terms&nbsp;|&nbsp;</span>
                          <span className={Styles.footerTextItem} onClick={() => this._terms("privacy")}>Privacy&nbsp;|&nbsp;</span>
                          <span className={Styles.footerTextItem} onClick={() => this._terms("acceptance")}>Acceptance&nbsp;|&nbsp;</span>
                          <span>© {this.state.year} saleschannel</span>
                      </div>
                  </div>
              </div>
        );
    }

}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/home/component.js